<template>
  <div id="eyejack-preview" v-if="hydrated">
    <div class="header">
      <img class="ej-logo" src="./assets/ej_logo.png" alt="eyejack"/>
      <h1>EyeJack</h1>
    </div>
    <transition name="fade">
      <div v-show="loading" class="loading-overlay">
        <div class="sk-circle">
          <div class="sk-circle1 sk-child"></div>
          <div class="sk-circle2 sk-child"></div>
          <div class="sk-circle3 sk-child"></div>
          <div class="sk-circle4 sk-child"></div>
          <div class="sk-circle5 sk-child"></div>
          <div class="sk-circle6 sk-child"></div>
          <div class="sk-circle7 sk-child"></div>
          <div class="sk-circle8 sk-child"></div>
          <div class="sk-circle9 sk-child"></div>
          <div class="sk-circle10 sk-child"></div>
          <div class="sk-circle11 sk-child"></div>
          <div class="sk-circle12 sk-child"></div>
        </div>
      </div>
    </transition>
    <div class="desktop-content">
      <div class="no-error" v-if="queryString">
        <div class="flex-container">
          <div class="page-half">
            <div class="page-half-container">
              <transition name="fade">
                <img v-if="markerSrc" class="marker" :src="markerSrc" alt="marker" @error="imageLoadError">
              </transition>
            </div>
          </div>
          <div id="divider"></div>
          <div class="page-half">
            <div id="right" class="page-half-container">
              <div class="flex-container-vertical">
                <div class="right-copy-container">
                  <h2>Scan the QR code with the EyeJack app to see your artwork come to life.</h2>
                </div>
                <div class="right-qr-container">
                  <div class="flex-container">
                    <div class="qr-container">
                      <div class="qr-placeholder">
                        <transition name="fade">
                          <img v-if="qrSrc" class="qr-code" :src="qrSrc" alt="qr code" @error="imageLoadError">
                        </transition>
                      </div>
                    </div>
                    <div class="qr-scan-container">
                      <img class="qr-scan-asset" src="./assets/ej_phone_qr@2x.png" alt="scan with mobile">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <h3>Get the EyeJack app on the App Store.</h3>
          <a href="https://itunes.apple.com/au/app/eyejack/id1163248223?mt=8" target="_blank">
            <div id="store" class="button"></div>
          </a>
        </div>
      </div>
      <div class="error" v-if="!queryString">
        <h2 style="margin-bottom: 1vw">Whoops!</h2>
        <h3 style="margin: 0;">Invalid artwork ID.</h3>
      </div>
    </div>
    <div class="mobile-content">
      <div class="no-error" v-if="queryString">
        <img v-if="markerSrc" class="mobile-marker" :src="markerSrc" alt="marker" @error="imageLoadError">
        <div class="overlay-container">
          <div class="mobile-marker-overlay"></div>
        </div>
        <div class="lower-content">
          <h1 class="mobile">View this artwork in the EyeJack app.</h1>
          <!-- iOS buttons -->
          <div class="buttons" v-if="this.platform === 'iOS'">
            <a id="android-launch-container" :href="iosLaunchURL" target="_blank">
              <div id="launch" class="button" @click="trackButton('Launch in EyeJack')"></div>
            </a>
            <!-- <a href="https://itunes.apple.com/au/app/eyejack/id1163248223?mt=8" target="_blank">
              <div id="appstore" class="button" @click="trackButton('App Store')"></div>
            </a> -->
          </div>
          <!-- android buttons -->
          <div class="buttons" v-else>
            <!-- <a :href="androidlaunchURL" target="_blank">
              <div id="launch" class="button" @click="trackButton('Launch in EyeJack')"></div>
            </a> -->
            <!-- <a href="https://play.google.com/store/apps/details?id=com.eyejackapp&hl=en_AU" target="_blank">
              <div id="playstore" class="button" @click="trackButton('App Store')"></div>
            </a> -->
            <a id="android-launch-container" :href="androidLaunchURL">
              <div id="android-launch" class="button" @click="trackButton('App Store')"></div>
            </a>
          </div>
        </div>
        <!-- <div class="lower-content">
          <div class="copy-container" v-if="this.platform === 'iOS'">
            <h5>View this artwork in the EyeJack app.</h5>
          </div>
          <div class="android-copy-container" v-if="this.platform !== 'iOS'">
            <h5>This feature is only available on iOS.</h5>
            <h5 class="coming-soon" v-if="this.platform !== 'iOS'">Android support coming soon!</h5>
          </div>
          <div id="buttons" class="flex-container" v-if="this.platform === 'iOS'">
            <div class="button-container">
              <a :href="launchURL" target="_blank">
                <div id="launch" class="button" @click="trackButton('Launch in EyeJack')"></div>
              </a>
            </div>
            <div class="button-container">
              <a href="https://itunes.apple.com/au/app/eyejack/id1163248223?mt=8" target="_blank">
                <div id="store" class="button" @click="trackButton('App Store')"></div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
      <div class="error" v-if="!queryString">
        <h2 style="margin-bottom: 3vw; margin-top: 80px;">Whoops!</h2>
        <h3 style="margin: 0;">Invalid artwork ID.</h3>
      </div>
    </div>
  </div>
</template>

<script>
import GetArtwork from './queries/GetArtwork'

export default {
  name: 'eyejack-preview',
  data () {
    return {
      testqs: 'eaf358c0-4dc6-11e8-9043-87f6b211cbda',
      platform: '',
      queryKey: '',
      queryString: '',
      iosLaunchURL: '',
      androidLaunchURL: '',
      markerSrc: '',
      qrSrc: '',
      hydrated: false,
      loading: true,
    }
  },
  metaInfo () {
    return {
      title: 'EyeJack Preview',
      meta: [
        // OpenGraph data (Most widely used)
        {property: 'og:title', content: 'EyeJack Preview'},
        {property: 'og:site_name', content: 'EyeJack Preview'},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: window.location.href},
        // {property: 'og:image', content: this.markerSrcMeta},
        {property: 'og:description', content: 'Check out this AR artwork made with EyeJack!'},
        // Twitter card
        {name: 'twitter:card', content: 'summary'},
        {name: 'twitter:site', content: window.location.href},
        {name: 'twitter:title', content: 'EyeJack Preview'},
        {name: 'twitter:description', content: 'Check out this AR artwork made with EyeJack!'},
        {name: 'twitter:creator', content: '@eyejackapp'},
        // Google / Schema.org markup:
        {itemprop: 'name', content: 'EyeJack Preview'},
        {itemprop: 'description', content: 'Check out this AR artwork made with EyeJack!'},
        // Default
        {name: 'description', content: 'Check out this AR artwork made with EyeJack!'}
      ]
    }
  },
  methods: {
    checkPlatform () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
        this.platform = 'Android'
      } else {
        this.platform = 'iOS'
      }
    },
    getImageURLs () {
      this.markerSrc = 'https://cdn.eyejackapp.com/art/prd/v1/' + this.queryString + '/' + this.queryString + '-artwork1024.jpg'
      this.qrSrc = 'https://cdn.eyejackapp.com/art/prd/v1/' + this.queryString + '/' + this.queryString + '-qr.png'
      this.loading = false
      this.setImageMetadata()
    },
    imageLoadError () {
      this.queryString = ''
    },
    getContent (_id) {
      if (this.queryKey === 'art') {
        this.$apollo.provider.defaultClient.query({ query: GetArtwork, variables: { id: _id }})
          .then(result => {
            if (result.data.getArtwork) {
              let qrIndex = result.data.getArtwork.files.map(file => {
                return file['type']
              }).indexOf('qrCode')
              this.qrSrc = result.data.getArtwork.files[qrIndex].path
              let markerIndex = result.data.getArtwork.files.map(file => {
                return file['type']
              }).indexOf('artwork512')
              this.markerSrc = result.data.getArtwork.files[markerIndex].path
              this.loading = false
              this.setImageMetadata()
            } else {
              this.getImageURLs(_id)
            }
          })
      } else if (this.queryKey === 'listing') {
        let requestUrl = `http://api.eyejackapp.com/api/prd/v3/listings/${_id}?include=packs`
        fetch(requestUrl)
          .then(data => { return data.json() })
          .then(result => {
            let markerIndex = result.included[0].attributes.files.map(file => {
              return file['file-type']
            }).indexOf('image-featured-1242')
            this.markerSrc = result.included[0].attributes.files[markerIndex].path
            let qrIndex = result.included[0].attributes.files.map(file => {
              return file['file-type']
            }).indexOf('qr-code')
            this.qrSrc = result.included[0].attributes.files[qrIndex].path
            this.loading = false
          })
      } else {
        this.loading = false
        this.queryString = ''
      }
    },
    setImageMetadata () {
      var meta = document.createElement('meta')
      meta.setAttribute('property', 'og:image')
      meta.content = this.markerSrc
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    trackButton (button) {
      gtag('event', button + ' button clicked', {
        'event_category': 'Buttons'
      })
    }
  },
  created () {
    this.$apollo.provider.defaultClient.hydrated()
      .then(() => {
        this.hydrated = true
        let rawQueryString = window.location.href.split('?').pop()
        this.queryKey = rawQueryString.split('=').shift()
        this.queryString = rawQueryString.split('=').pop()
        if (this.queryString === window.location.href) {
          this.queryString = ''
          this.loading = false
        } else {
          this.iosLaunchURL = 'https://eyejack.page.link/?link=' + 'http://cdn.eyejackapp.com/qr/a.html?' + encodeURIComponent(this.queryKey + '=' + this.queryString) + '&apn=com.eyejackapp&amv=24&isi=1163248223&ibi=com.eyejackapp.EyeJack&ius=eyejack&efr=1'
          this.androidLaunchURL = 'https://eyejack.page.link/?link=' + 'http://cdn.eyejackapp.com/qr/a.html?' + encodeURIComponent(this.queryKey + '=' + this.queryString) + '&apn=com.eyejackapp&amv=24&isi=1163248223&ibi=com.eyejackapp.EyeJack&ius=eyejack&efr=1'
          this.getContent(this.queryString)
        }
      })
    this.checkPlatform()
    // this.getImageURLs()

    let trackingID = process.env.NODE_ENV === 'production' ? 'UA-118063407-5' : 'UA-118063407-4'
    let tagManagerScript = document.createElement('script')
    tagManagerScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + trackingID)
    document.head.appendChild(tagManagerScript)
    let dataLayerScript = document.createElement('script')
    dataLayerScript.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '" + trackingID + "');"
    document.head.appendChild(dataLayerScript)
  }
}
</script>

<style>
.buttons {
  display: flex;
  flex: 1;
  box-sizing: border-box;
  justify-content: space-around;
}

.buttons > a {
  flex: 1;
  margin: 10px;
}

.buttons > a > div {
  width: 100%;
  height: 60px;
}

#playstore {
  background-color: #000000;
  background-image: url("./assets/google-play-badge.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

#appstore {
  background-color: #000000;
  background-image: url("./assets/appstore.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

#launch {
  background-color: #E95557;
  background-image: url("./assets/launch_eyejack@2x.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

#android-launch-container {
  max-width: 170px;
}

#android-launch {
  background-color: #E95557;
  background-image: url("./assets/launch_eyejack@2x.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  max-width: 170px;
}

/* typography */
h1, h2, h3, h4, h5, span {
  font-family: 'Helvetica', sans-serif;
  line-height: 1.1;
}

h1 {
  font-weight: bold;
  /* font-size: 2.5em; */
  font-size: 3.6vw;
  margin: 3px 0 0 11vw;
  color: #FFFFFF;
  letter-spacing: 1px;
}
h2 {
  margin: 0;
  font-size: 2.8vw;
  line-height: 1.2 !important;
  font-weight: lighter;
  color: #666666;
}
h3 {
  margin: 4vw;
  font-size: 2.4vw;
  font-weight: lighter;
  color: #222222;
}
h4 {
  margin: 4vw;
  font-size: 1.8vw;
  font-weight: lighter;
  color: #222222;
}
h5 {
  margin: 0;
  font-size: 6.5vw;
  font-weight: lighter;
  color: #FFFFFF;
  line-height: 1.2;
}
.coming-soon {
  font-size: 5.5vw;
  margin-top: 30px;
}

/* media queries */
@media screen and (max-width: 769.98px) {
  .desktop-content {
    display: none;
  }
  h1 {
    font-size: 1.55em;
    margin-left: 65px;
  }
  h1.mobile {
  font-size: 1.8em;
  font-weight: lighter;
  color: #FFFFFF;
  line-height: 1.2;
  margin: 0 0 20px 0;
  }
  h2 {
    font-size: 6.8vw;
  }
  h3 {
    font-size: 6.4vw;
  }
  .header {
    padding: 10px 20px !important;
    height: 52px !important;
    position: absolute !important;
    width: 100vw;
  }
  .ej-logo {
    height: 32px !important;
  }
  .button {
    height: 10vw !important;
    border-radius: 1.5vw !important;
  }
}

@media screen and (min-width: 770px) {
  .mobile-content {
    display: none;
  }
  .button {
    width: 20vw !important;
  }
}

@media screen and (min-width: 1100px) {
  h1 {
    font-size: 2.5em;
    margin-left: 115px !important;
  }
  .header {
    padding: 18px 30px !important;
  }
  .ej-logo {
    height: 50px !important;
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .75);
  /* opacity: 0.8; */
  z-index: 2;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* mobile css */
.mobile-marker {
  position: absolute;
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
  z-index: -2;
  top: 0px;
}
.overlay-container {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
}
.mobile-marker-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
}
.lower-content {
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  /* border: 1px solid blue; */
  padding: 20px;
  box-sizing: border-box;
}
.copy-container {
  box-sizing: border-box;
  width: 100vw;
  padding: 0 10vw;
}
.android-copy-container {
  box-sizing: border-box;
  width: 100vw;
  padding: 0 5vw;
  margin-bottom: 70px;
}
.button-container {
  box-sizing: content-box;
  flex: 1;
  /* border: 1px solid red; */
  padding: 35px 0;
}
.button {
  width: 35vw;
  height: 6vw;
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  margin: 0 auto;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.2);
}
#buttons {
  padding: 0 20px;
  box-sizing: border-box;
}
#store {
  background-color: #000000;
  background-image: url("./assets/appstore.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
#launch {
  background-color: #E95557;
  background-image: url("./assets/launch_eyejack@2x.png");
  background-position: center;
  background-repeat: no-repeat;
  /* background-size: contain; */
  background-size: auto 90%;
}
.button-text {
  width: 103px;
  margin: 7px auto;
}

/* divs */
html, body {
  padding: 0;
  margin: 0;
}
.header {
  /* height: 85px; */
  height: 8vw;
  max-height: 85px;
  background: #E95557;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.54);
  position: relative;
  padding: 1.6vw 3vw;
  box-sizing: border-box;
  z-index: 3;
}
.ej-logo {
  float: left;
  height: 4.7vw;
}
.flex-container {
  display: flex;
  width: 100%;
  height: 100%;
  margin:0;
  padding:0;
}
.flex-container-vertical {
  display: flex;
  flex-flow: column;
  height: 100%;
  margin:0;
  padding:0;
}
#divider {
  background: #FFFFFF;
  flex: 0.5;
}
#right {
  margin-left: 2.5%
}
.page-half {
  /* width: 50vw; */
  height: 49.75vw;
  /* padding-bottom: 50vw; */
  background: #F4F4F4;
  flex: 49.5;
}
.page-half-container {
  /* padding: 60px 80px; */
  padding: 5.5vw;
  height: 49.75vw;
  box-sizing: border-box;
}
.footer {
  text-align: center;
  background: #FFFFFF;
  width: 100%;
  height: 100px;
  margin:0;
  padding:0;
  float: left;
}
.marker {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
.qr-code {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 5px;
}
.qr-scan-asset {
  width: 90%;
  height: 100%;
  object-fit: scale-down;
}
.qr-container {
  flex: 8;
  height: 100%;
  border: 0.2vw solid #444444;
  border-radius: 0.8vw;
  box-sizing: border-box;
  background: #FFFFFF;
  padding: 1px;
}
.qr-scan-container {
  flex: 4;
  height: 100%;
  max-width: 150px;
}
.right-copy-container {
  width: 33vw;
  flex: 9;
  /* max-height: 160px; */
}
.right-qr-container {
  flex: 9;
}
.qr-placeholder {
  width: 100%;
  height: 24.6vw;
}
.error {
  padding: 5vw;
  text-align: center;
}
.no-error {
  /* position: relative;
  height: 100%;
  width: 100%; */
}
.mobile-content {
  width: 100%;
  height: 100%;
}

.sk-circle {
  margin: 38vh auto;
  width: 70px;
  height: 70px;
  position: relative;
}
.sk-circle .sk-child {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.sk-circle .sk-child:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #fff;
  border-radius: 100%;
  -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
          animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
}
.sk-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
      -ms-transform: rotate(30deg);
          transform: rotate(30deg); }
.sk-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
      -ms-transform: rotate(60deg);
          transform: rotate(60deg); }
.sk-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg); }
.sk-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
      -ms-transform: rotate(120deg);
          transform: rotate(120deg); }
.sk-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
      -ms-transform: rotate(150deg);
          transform: rotate(150deg); }
.sk-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg); }
.sk-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
      -ms-transform: rotate(210deg);
          transform: rotate(210deg); }
.sk-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
      -ms-transform: rotate(240deg);
          transform: rotate(240deg); }
.sk-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
          transform: rotate(270deg); }
.sk-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
      -ms-transform: rotate(300deg);
          transform: rotate(300deg); }
.sk-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
      -ms-transform: rotate(330deg);
          transform: rotate(330deg); }
.sk-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s; }
.sk-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
          animation-delay: -1s; }
.sk-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s; }
.sk-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s; }
.sk-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
          animation-delay: -0.7s; }
.sk-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
          animation-delay: -0.6s; }
.sk-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
          animation-delay: -0.5s; }
.sk-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
          animation-delay: -0.4s; }
.sk-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
          animation-delay: -0.3s; }
.sk-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
          animation-delay: -0.2s; }
.sk-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
          animation-delay: -0.1s; }

@-webkit-keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

@keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
</style>
